import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, ArrowRight } from 'lucide-react';

/**
 * Soft conversion banner shown at the bottom of every blog post.
 *
 * Targets readers of our ADHD / autism / communication articles — exactly
 * the audience whose org or therapy practice could benefit from partnering.
 * Kept intentionally low-key (no shouting CTAs) so it complements long-form
 * content instead of interrupting it.
 */
export const PartnersBlogBanner = () => {
  return (
    <aside
      className="mt-10 not-prose rounded-2xl border border-[#00E5CC]/30 bg-gradient-to-br from-[#00E5CC]/10 via-cyan-500/5 to-purple-500/10 p-5 sm:p-6"
      data-testid="partners-blog-banner"
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="shrink-0 w-12 h-12 rounded-xl bg-white/70 dark:bg-card/70 flex items-center justify-center shadow-sm">
          <Building2 className="h-6 w-6 text-[#00A896]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm sm:text-base font-semibold leading-tight">
            Use ClearCommunicationApp with your students or clients?
          </p>
          <p className="text-xs sm:text-sm text-muted-foreground mt-1 leading-relaxed">
            Autism organizations, schools, and therapy practices: explore three lightweight
            partnership tiers — from a quick newsletter share to a co-branded pilot.
          </p>
        </div>
        <Link
          to="/for-organizations"
          className="shrink-0 inline-flex items-center gap-1 px-4 py-2 rounded-full bg-[#00E5CC] hover:bg-[#00C9B3] text-[#0d1f2d] text-sm font-medium transition-colors shadow-sm hover:shadow-md whitespace-nowrap"
          data-testid="partners-blog-banner-cta"
        >
          Learn about partnerships
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </aside>
  );
};

export default PartnersBlogBanner;
